import { PageGen, PdfRect, PdfUnit, PdfBrush, PdfColor, ETextAlign } from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaYellow implements IColorSchema {
  readonly name = 'Yellow';

  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);
  private sizeTopMargin = PdfUnit.FromMillimeters(3);
  private sizeBottomMargin = PdfUnit.FromMillimeters(3);

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `- ${pageNumber} -`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    let left = rect.x;
    const top = (this.sizeTopHeader - this.sizeTopTitle) / 2;

    // Yellow header bar (offset to leave room for circle)
    const rt = new PdfRect(
      rect.x + this.sizeTopHeader / 2,
      rect.y + top,
      rect.width - this.sizeTopHeader / 2,
      this.sizeTopTitle
    );
    page.drawRectangle(null, new PdfBrush(PdfColor.fromRgb(255, 246, 136)), rt);

    if (counter) {
      // Orange circle counter
      const r1 = new PdfRect(left, rect.y, this.sizeTopHeader, this.sizeTopHeader);
      page.drawEllipse(null, new PdfBrush(PdfColor.fromRgb(255, 204, 41)), r1);
      page.drawString(counter, font, PdfBrush.Black, null, r1, ETextAlign.Center);
      left += r1.width + this.marginTop;
    }

    if (title) {
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.CenterLeft);
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    page.drawRectangle(null, new PdfBrush(PdfColor.fromRgb(255, 252, 208)), rect);
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x,
      rect.y + this.sizeTopHeader + this.sizeTopMargin,
      rect.width,
      rect.height - this.sizeTopHeader - this.sizeBottomMargin - this.sizeBottomMargin
    );
  }
}
